import React from 'react';

import { $config } from '@client/core/atoms/config';

import { ObjectExplorer } from '../ObjectExplorer';

export function DataTab() {
  const config = $config.get();
  return (
    <div className="ml-8 mr-8 flex flex-col gap-4">
      <ObjectExplorer data={config} />
    </div>
  );
}

DataTab.friendlyName = 'Data' as const;
